/* @ngInject */
function httpInterceptor($q, RouterService, AuthService) {
  const service = {
    request,
    requestError,
    response,
    responseError,
  };

  return service;

  function request(config) {
    if (!config.url.includes('login')) {
      config.headers.Authorization = config.headers.Authorization || AuthService.createAuthorization();
    }
    return config;
  }

  function requestError(rejection) {
    return $q.reject(rejection);
  }

  function response(result) {
    return result;
  }

  function responseError(rejection) {
    if (rejection.status === 401) {
      AuthService.token(null);
      RouterService.state.go('login');
    }
    return $q.reject(rejection);
  }
}

export default httpInterceptor;



// WEBPACK FOOTER //
// ./src/app/core/http/http.interceptor.factory.js